export interface PHASE_ONE {
  DoneBySkip?: boolean;
  Edited?: boolean;
  ThreeData?: {
    BusinessLogoFolderName: string;
    BusinessLogoName: string;
    BusinessLogoPath: string;
    BusinessPhoneNumber: string;
    HaveTax: boolean;
    PriceIncludeTax: boolean;
    TaxRate: number;
  };
}

export interface PHASE_TWO {
  DoneBySkip?: boolean;
  Edited?: boolean;
  FourData?: {
    RegistrationServiceCategories?: {
      BusinessTypeId?: number;
      GlobalName?: string;
      RegistrationServices?: {
        ServiceId?: number;
        ServicePrice?: number;
      }[];
    }[];
  };
}

export interface SERVICE_FORM {
  BusinessTypeId?: number;
  RegistrationServices?: {
    ServiceId?: number;
    ServicePrice?: number;
  }[];
}

export interface PHASE_THREE {
  DoneBySkip?: boolean;
  Edited?: boolean;
  FiveData?: {
    EmployeesNames: string[];
    NumberOfBranches: number;
    PositionId: number;
  };
}

export interface WorkingHours {
  WeekDay: number;
  IsDayOff?: boolean;
  FinishTime?: string;
  StartTime?: string;
}

export interface PHASE_FIVE {
  DoneBySkip?: boolean;
  Edited?: boolean;
  SixData?: {
    WorkingHours: WorkingHours[];
  };
}
